<template>
  <div class="or-container">
    <div class="or-clause" ref="container">
      <div ref="ands"></div>
      <div class="row d-flex flex-row and-clause-button-row">
        <span @click="onClick" class="and-clause-button blue-button">
          <plus-circle-outline />
          {{this.$i18n.ADD_AND_BLOCK}}
        </span>

        <span class="and-clause-button red-button" @click="$emit('deleteMe')">
          {{this.$i18n.REMOVE_QUERY_BLOCK}}
          <close-circle />
        </span>
      </div>
    </div>

    <span class="or-indicator">{{this.$i18n.OR}}</span>
  </div>
</template>

<script>
import Vue from "vue";
import AndClause from "./and-clause";
import CloseCircle from "vue-material-design-icons/CloseCircle.vue";
import PlusCircleOutline from "vue-material-design-icons/PlusCircleOutline.vue";

export default {
  name: "OrClause",
  components: { AndClause, CloseCircle, PlusCircleOutline },
  props: {
    module: String
  },
  data: function() {
    return {
      andClauses: [],
      id: ""
    };
  },
  mounted() {
    this.onClick();

    // generating GUID
    var result, i, j;
    result = "";
    for (j = 0; j < 32; j++) {
      if (j == 8 || j == 12 || j == 16 || j == 20) result = result + "-";
      i = Math.floor(Math.random() * 16)
        .toString(16)
        .toUpperCase();
      result = result + i;
    }

    this.id = result;
  },
  methods: {
    addInitialClause() {
      if (this.andClauses.length === 0) this.onClick();
    },
    onClick() {
      let ComponentClass = Vue.extend(AndClause);
      let instance = new ComponentClass({
        store: this.$store,
        propsData: { module: this.module }
      });
      instance.$mount(); // pass nothing
      instance.$parent = this;
      instance.$on("deleteMe", function() {
        instance.$destroy(true);
        instance.$el.remove();
        this.$parent.$emit("updateTree");
      });
      instance.$on("updateTree", function() {
        this.$parent.$emit("updateTree");
      });
      this.$refs.ands.appendChild(instance.$el);
      this.andClauses.push(instance);
    }
  }
};
</script>
<style scoped>
.or-clause {
  background: #f2f7f8;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  padding-bottom: 10px;
}

.or-container {
  padding-bottom: 20px;
}

.or-indicator {
  padding-left: 15px;
}

.and-clause-button {
  cursor: pointer;
  padding-right: 5px;
}

.and-clause-button-row {
  justify-content: space-between;
  padding-left: 30px;
  padding-right: 30px;
}

.or-container:last-of-type .or-indicator {
  display: none !important;
}

.mdi-plus-circle {
  color: #009efb;
  font-size: 20px;
}

.mdi-close-circle {
  color: palevioletred;
  font-size: 20px;
  cursor: pointer;
}
</style>
